import { Action } from '@ngrx/store';
import { SurveyInterface } from 'app/assessment/survey/models';

import { SurveyActionType } from './survey-action-type.enum';

// surveys
export class UpdateSurvey implements Action {
  public readonly type: SurveyActionType = SurveyActionType.UpdateSurvey;

  constructor(public readonly payload: SurveyInterface) { }
}

export class UpdateSurveyCompleted implements Action {
  public readonly type: SurveyActionType = SurveyActionType.UpdateSurveyCompleted;

  constructor(public readonly payload: SurveyInterface) { }
}

export class UpdateSurveyFailed implements Action {
  public readonly type: SurveyActionType = SurveyActionType.UpdateSurveyFailed;

  constructor(public readonly payload: string) { }
}

// survey progress
export class UpdateSurveyProgress implements Action {
  public readonly type: SurveyActionType = SurveyActionType.UpdateSurveyProgress;

  constructor(public readonly payload: number) { }
}

export class UpdateSurveyProgressCompleted implements Action {
  public readonly type: SurveyActionType = SurveyActionType.UpdateSurveyProgressCompleted;

  constructor(public readonly payload: number) { }
}

export class UpdateSurveyProgressFailed implements Action {
  public readonly type: SurveyActionType = SurveyActionType.UpdateSurveyProgressFailed;

  constructor(public readonly payload: string) { }
}

// current survey
export class UpdateCurrentSurvey implements Action {
  public readonly type: SurveyActionType = SurveyActionType.UpdateCurrentSurvey;

  constructor(public readonly payload: SurveyInterface) { }
}

export class UpdateCurrentSurveyCompleted implements Action {
  public readonly type: SurveyActionType = SurveyActionType.UpdateCurrentSurveyCompleted;

  constructor(public readonly payload: SurveyInterface) { }
}

export class UpdateCurrentSurveyFailed implements Action {
  public readonly type: SurveyActionType = SurveyActionType.UpdateCurrentSurveyFailed;

  constructor(public readonly payload: string) { }
}

export class ResetCurrentSurvey implements Action {
  public readonly type: SurveyActionType = SurveyActionType.ResetCurrentSurvey;

  constructor(public readonly payload: SurveyInterface) { }
}

export class ResetCurrentSurveyCompleted implements Action {
  public readonly type: SurveyActionType = SurveyActionType.ResetCurrentSurveyCompleted;

  constructor(public readonly payload: SurveyInterface) { }
}

export class ResetCurrentSurveyFailed implements Action {
  public readonly type: SurveyActionType = SurveyActionType.ResetCurrentSurveyFailed;

  constructor(public readonly payload: string) { }
}
